<div class="container py-5">
    <div class="row mt-5">
        <div class="col-1">
            <!-- <img routerLink="/category" class="c-pointer" src="assets/icons/back.svg" alt=""> -->
        </div>
        <div class="col-10 text-center">
            <div class="d-flex justify-content-center align-items-start gap-4">
                <h1 class="text-36-600-119 text-c4">
                    {{'Quiz Instructions' | translate}}
                </h1>
                <img src="assets/icons/instruction.svg" alt="">
            </div>
            <!-- instructions -->
            <div class="mt-5 mb-5">
                <div *ngFor="let inst of instructions" class="instruction mb-4 d-flex align-items-center gap-4">
                    <span class="no text-14-500-142 text-c2">{{inst.no}}</span>
                    <p class="mb-0 text-18-500-150 text-c4 text-start">{{inst.text | translate}}</p>
                </div>
            </div>
            <button routerLink="/join-team" class="ctn-btn text-16-500-125">{{'Continue' | translate}}</button>
        </div>
    </div>
</div>
